__turbopack_context__.v({
  "actions": "membership-invoice-module-scss-module__IHDqVG__actions",
  "actions__button-icon": "membership-invoice-module-scss-module__IHDqVG__actions__button-icon",
  "receipt": "membership-invoice-module-scss-module__IHDqVG__receipt",
  "receipt__header": "membership-invoice-module-scss-module__IHDqVG__receipt__header",
  "receipt__section": "membership-invoice-module-scss-module__IHDqVG__receipt__section",
  "receipt__section-content": "membership-invoice-module-scss-module__IHDqVG__receipt__section-content",
  "receipt__section-item": "membership-invoice-module-scss-module__IHDqVG__receipt__section-item",
  "receipt__section-item-value--capitalized": "membership-invoice-module-scss-module__IHDqVG__receipt__section-item-value--capitalized",
  "receipt__section-title": "membership-invoice-module-scss-module__IHDqVG__receipt__section-title",
});
